/**
 * http://usejsdoc.org/
 */

 const load1 = {    
					plane: 'caravan',
					pilotId: 'asfasf2avasd23232dvad',
				    loadNum: 1,
				    totalJumpers: 17,
				    totalSlots: 15,
				    tandemJumps: [ 
					   { 
                           jumpId: 1,
						   instructor:{
                                _id: '121231231ADASF',
                                firstname: "Jack",
                                lastname: "John",
                                memberId: "2324323"
                           },
                           student:{
                                _id: '23efasdfsadfsafasf',
                                firstname: "jack",
                                lastname: "john"
                           },
                           videographer:{
                               _id: 'asdf2vasdfasfsaf',
                               firstname: "Blake",
                               lastname: "Bloke",
                               memberId: "123212"
                           }
				       },
                       { 
                           jumpId: 2,
						   instructor:{
                                _id: '12123asdfdF',
                                firstname: "Josh",
                                lastname: "Stagger",
                                memberId: "2324323"
                           },
                           student:{
                                _id: '23efasdfsad111fasf',
                                firstname: "Melanie",
                                lastname: "Rose"
                           },
                           videographer:{
                               _id: 'asdf2vasdfasfsaf',
                               firstname: "Blake",
                               lastname: "Bloke",
                               memberId: "133998"
                           }
				       }
				    ],
				    affJumps: [ 
				    	{ 
                            level: 1,
				    		jumpId: 3,
				    		mainInstructor: {
                                _id: "23fasvvasdf232a",
                                firstname: "dan",
                                lastname: "chaudhry",
                                memberId: "2323343"
                            },
                            student:{
                                _id: "2dsf3fdewd4eed234",
                                firstname: "chaudhry",
                                lastname: "khan"
                            },
				    		secondaryInstructor: {
                                _id: "dsdf323sadf2323",
                                firstname: "Jake",
                                lastname: "blake",
                                memberId: "333223"
                            } 
				    	},
				    	{ 
                            level: 4,
				    		jumpId: 4,
				    		mainInstructor: {
                                _id: "23fasvvasdf232a",
                                firstname: "Vaibhav",
                                lastname: "Patle",
                                memberId: "2323343"
                            },
                            student:{
                                _id: "2dsf3fdewd4eed234",
                                firstname: "Rasil",
                                lastname: "asdkfjasd"
                            }
                        } 
                    ],
				    funJumps: [
				    	{ 
				    		jumpType: 'FREEFLY',
				    		jumpId: 5,
				    		jumpers: [
                                {
                                    _id: "23fasvvasdf232a",
                                    firstname: "Vaibhav",
                                    lastname: "Patle",
                                    memberId: "2323343",
                                    gearRental: true
                                }, 
                                {
                                    _id: "23fasvvasdf232a",
                                    firstname: "Vaibhav",
                                    lastname: "Patle",
                                    memberId: "2323343"
                                },
                                {
                                    _id: "23fasvvasdf232a",
                                    firstname: "Vaibhav",
                                    lastname: "Patle",
                                    memberId: "2323343"
                                } ],
				    	},
				    	{ 
				    		jumpType: 'BELLY',
				    		jumpId: 6,
				    		jumpers: [
                                {
                                    _id: "23fasvvasdf232a",
                                    firstname: "Vaibhav",
                                    lastname: "Patle",
                                    memberId: "2323343",
                                    gearRental: true
                                }, 
                                {
                                    _id: "23fasvvasdf232a",
                                    firstname: "Vaibhav",
                                    lastname: "Patle",
                                    memberId: "2323343"
                                },
                                {
                                    _id: "23fasvvasdf232a",
                                    firstname: "Vaibhav",
                                    lastname: "Patle",
                                    memberId: "2323343"
                                } ],
				    	},
				    	{ 
				    		jumpType: 'HOPNPOP',
				    		jumpId: 7,
				    		jumpers: [
                                {
                                    _id: "23fasvvasdf232a",
                                    firstname: "Vaibhav",
                                    lastname: "Patle",
                                    memberId: "2323343",
                                    gearRental: true
                                }]
				    	}
				    ] 
                };
                
const load2 = { 
					plane: 'otter',
					pilotId: "1323fasbasdf32",
				    loadNum: 2,
				    totalJumpers: 19,
				    totalSlots: 15,
				    tandemJumps: [ 
					   { 
                           jumpId: 1,
						   instructor:{
                                _id: '121231231ADASF',
                                firstname: "Justin",
                                lastname: "Hoffman",
                                memberId: "2324311"
                           },
                           student:{
                                _id: '23efasdfsadfsafasf',
                                firstname: "jack",
                                lastname: "john"
                           }
				       },
                       { 
                           jumpId: 2,
						   instructor:{
                                _id: '12123asdfdFasdf23',
                                firstname: "Josh",
                                lastname: "Stagger",
                                memberId: "2324323"
                           },
                           student:{
                                _id: '23efasdfsad111fasf',
                                firstname: "Melanie",
                                lastname: "Rose"
                           }
                       },
                       { 
                           jumpId:3,
						   instructor:{
                                _id: '121231231ADASF',
                                firstname: "Robert",
                                lastname: "Enckle",
                                memberId: "238323"
                           },
                           student:{
                                _id: '23efasdfsadfsafasf',
                                firstname: "Eric",
                                lastname: "Sibila"
                           },
                           videographer:{
                               _id: 'asdf2vasdfasfsaf',
                               firstname: "Blake",
                               lastname: "Bloke",
                               memberId: "123212"
                           }
				       },
                       { 
                           jumpId: 4,
						   instructor:{
                                _id: '12123asdfdF',
                                firstname: "Josh",
                                lastname: "Stagger",
                                memberId: "2324323"
                           },
                           student:{
                                _id: '23efasdfsad111fasf',
                                firstname: "Melanie",
                                lastname: "Rose"
                           },
                           videographer:{
                               _id: 'asdf2vasdfasfsaf',
                               firstname: "Blake",
                               lastname: "Bloke",
                               memberId: "133998"
                           }
				       }
				    ],
				    affJumps: [ 
				    	{ 
                            level: 1,
				    		jumpId: 5,
				    		mainInstructor: {
                                _id: "23fasvvasdf232a",
                                firstname: "dan",
                                lastname: "chaudhry",
                                memberId: "2323343"
                            },
                            student:{
                                _id: "2dsf3fdewd4eed234",
                                firstname: "chaudhry",
                                lastname: "khan"
                            },
				    		secondaryInstructor: {
                                _id: "dsdf323sadf2323",
                                firstname: "Jake",
                                lastname: "blake",
                                memberId: "333223"
                            } 
				    	},
				    	{ 
                            level: 1,
				    		jumpId: 6,
				    		mainInstructor: {
                                _id: "23fasvvasdf232a",
                                firstname: "Remmy",
                                lastname: "chaudhry",
                                memberId: "211343"
                            },
                            student:{
                                _id: "2dsf3fdewd4eed234",
                                firstname: "chaudhry",
                                lastname: "khan"
                            },
				    		secondaryInstructor: {
                                _id: "dsdf323sadf2323",
                                firstname: "Jake",
                                lastname: "blake",
                                memberId: "333223"
                            } 
				    	},
				    	{ 
                            level: 1,
				    		jumpId: 7,
				    		mainInstructor: {
                                _id: "23fasvvasdf232a",
                                firstname: "dan",
                                lastname: "chaudhry",
                                memberId: "2323343"
                            },
                            student:{
                                _id: "2dsf3fdewd4eed234",
                                firstname: "chaudhry",
                                lastname: "khan"
                            },
				    		secondaryInstructor: {
                                _id: "dsdf323sadf2323",
                                firstname: "Jake",
                                lastname: "blake",
                                memberId: "333223"
                            } 
                        }
                    ],
				    funJumps: [] 
                };

const activeLoads = [load1, load2]
export default activeLoads;




